<template>
  <div class="contract-list">
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon> {{ $t("book/facility:gbu.title-export-data")}}

        </h2>
      </v-col>
    </v-row>
    <v-autocomplete
        v-if="isAdmin"
        v-model="selectedCustomerForAdmin"
        :items = "allCustomers"
        item-text="name"
        item-value="id"
        outlined
        @change="onCustomerSelectChange"
        :label = "$t('common:customer')"

    ></v-autocomplete>
    <data-table
        ref="table"
        :title="nrSelectedItems + ' ' + $t('book/facility:gbu.gbus-selected')"
        :headers="headers"
        :data="items"
        sort-by="name"
        enabledSearch

        @updateTableData="updateTable"

        :loading="!isDataLoaded"
        :trueFalseDecorateFields="trueFalseDecorateFields"
        enabled-select
        clearSelectionBtn
        :selected-text="$t('book/facility:gbu.button-export-excel')"
        action-icon="import_export"
        @clickedActionButton="onClickActionButton"

        @selection-changed="onItemSelectionChanged"
        add-top-scroll-bar
    >
    </data-table>
    <br>
  </div>

</template>

<script>
import Utils from "@/modules/core/services/utils";
import FacilityService from "@/modules/book/services/facility-service";
import DataTable from "@/modules/core/components/DataTable/DataTable.vue";
import CustomerService from "@/modules/core/services/customer-service";
import GbuResultService from "@/modules/book/services/gbu-result-service";
import * as XLSX from "xlsx-js-style"
import DocumentationService from "@/modules/core/services/documentation-service";
import DateUtils from "@/modules/core/services/date-utils";
import {mapGetters} from "vuex";
import DataUtils from "@/modules/core/services/data-utils";
import Customer from "@/modules/core/data/customer";


export default {
  name: "GbuExport",
  components: {
    DataTable,
  },
  data() {
    return {
      showAll: false,
      currentContract: {},
      isDataLoaded: false,
      tableConfigs: {
        options: {},
        search: ""
      },
      allFacilities: [],
      items: [],
      selectedItems: [],
      nrSelectedItems: 0,

      allCustomers: [],
      customerIdName: {},
      dataFacility: [],
      dataRisks: [],
      colsFacility: [],
      colsRisks: [],
      rowsFacility: [],
      rowsRisk: [],
      cellFormatEuro: '#,##0.00 [$€-de-DE];-#,##0.00 [$€-de-DE]',
      colCharsWidth: 26,  // column chars with for calculating number of lines
      fillHigh: { fgColor: { rgb: "FF0000" } },
      fillMedium: { fgColor: { rgb: "FF8000" } },
      fillLow: { fgColor: { rgb: "FFFF00" } },
      fillGray: { fgColor: { rgb: "808080" } },
      fillWhite: { fgColor: { rgb: "FFFFFF" } },

      selectedCustomerForAdmin: null,
    };
  },
  mounted() {

    this.isDataLoaded = false;
    // todo : admin

    CustomerService.readAllIdNamesFromAPI(
        (response)=> {
          this.allCustomers = response.data;
          this.customerIdName= {};
          for (let customer of this.allCustomers) {
            this.customerIdName[customer.id] = customer.name;
          }
          if (this.isAdmin) {
            CustomerService.readProfileFromAPI(
                (resp) => {
                  this.selectedCustomerForAdmin = DataUtils.parseDataToSingleObject(resp.data, Customer);
                });
          }
          FacilityService.readForGbuExport(
              this.readForGbuExportSucessHandler,
              () => {
                this.isDataLoaded = true;
                Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:facility_plural')}));
              }
          )
      },
    () => {
      this.isDataLoaded = true;
      Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:customer_plural')}));

    });

  },
  computed: {
    ...mapGetters('auth', ['isAdmin']),
    headers() {
      return [
        {text: this.$t('common:name'), value: 'name', default: true },
        {text: this.$t("common:facility-number"), value: "objectNumber"},

        {text: this.$t('book/facility:gbu.report-generated') , value: "hasGbuReport", sort:Utils.compareBooleanWithNullUndefined, },
        {text: this.$t('book/facility:gbu.cost-estimate'), value: "hasCostEstimate", sort:Utils.compareBooleanWithNullUndefined, },
        {text: this.$t('book/facility:gbu.inspection-date') , value: "inspectionDate", sort:Utils.compareLocalDeDateString, },
        {text: this.$t('book/facility:gbu.report-date') , value: "reportDate", sort:Utils.compareLocalDeDateString,},

        {text: this.$t("common:manager"), value: "managerName"},
        {text: this.$t("common:owner"), value: "buildingOwnerName"},
        {text: this.$t("common:operator"), value: "buildingOperatorName"},

        {text: this.$t("common:building"), value: "buildingName"},
        {text: this.$t("common:zip"), value: "buildingZip"},
        {text: this.$t("common:city"), value: "buildingCity"},
        {text: this.$t("common:address"), value: "buildingStreet"},

      ]
    },
    trueFalseDecorateFields() {
      return ['hasGbuReport', 'hasCostEstimate'] ;
    },
  },

  methods: {
    readForGbuExportSucessHandler(response) {

      this.allFacilities = response.data;
      for (let facility of  this.allFacilities) {
        facility.managerName = this.customerIdName[facility.manager];
        facility.buildingOwnerName = this.customerIdName[facility.buildingOwnerId];
        facility.buildingOperatorName = this.customerIdName[facility.buildingOperatorId];

        if (facility.latestGbuInfo) {
          facility.gbuId = facility.latestGbuInfo.gbuId;

          facility.inspectionDate = facility.latestGbuInfo.inspectionDate;
          facility.reportDate = facility.latestGbuInfo.reportDate;
          facility.hasGbuReport = facility.latestGbuInfo.reportDate != null;
          facility.hasCostEstimate = !facility.hasGbuReport ? null : facility.latestGbuInfo.hasCostEstimate;
        }
      }
      this.items = this.allFacilities;
      this.isDataLoaded = true;
    },

    updateTable(options, search) {

      this.tableConfigs.options = options;
      this.tableConfigs.search = search;

      this.$refs.table.loading = true;

      this.$refs.table.loading = false;
    },

    onItemSelectionChanged(items) {
      this.selectedItems = items;
      this.nrSelectedItems = items.length;
    },

    onClickActionButton(items) {
      this.selectedItems = items;
      this.nrSelectedItems = items.length;
      // todo block input with overlay
      let gbuIdList = [];
      for (let item of items) {
        if (item.latestGbuInfo && item.latestGbuInfo.id !== undefined) {
          gbuIdList.push(item.latestGbuInfo.id );
        }
      }
      GbuResultService.readMultipleFromAPI(gbuIdList,
          (response)=> {
            let gbus = {};
            for (let gbu of response.data) {
              gbus['id'+gbu.id] = gbu;
            }
            this.initSpreadsheetData();
            for (let facility of this.selectedItems) {
              if (facility.latestGbuInfo && facility.latestGbuInfo.id !== undefined)  {
                let gbu= gbus['id'+facility.latestGbuInfo.id];
                facility.gbu = gbu;
                this.addFacilityToData(facility);
              }
            }
            this.saveDataToExcel();
          },
      () => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: 'GBUs'}));
      });
    },

    initSpreadsheetData() {
      let bufferChars= 2;
      this.dataFacility = [[
        {v:"Anlage"}, {v:"Adresse"}, {v:"PLZ"}, {v:"Ort"},            // A-D
        {v:"transportiert"}, {v:"Tragfähigkeit"}, {v:"Haltestellen"}, // E-G
        {v:"Geschwindigkeit"}, {v:"Hydraulisch/Seil"}, {v:"Maschinenraum"}, {v:"Prüf-Datum"},    // H-K
        {v:'Bericht\nerzeugt'}, {v:'Kostenschätzung'},                         // L-M
        {v:'Anzahl Mängel\nRisiko hoch', s: { fill:this.fillHigh } } ,         // O
        {v:'Schätzkosten\nRisiko hoch', s: { fill:this.fillHigh } } ,          // P
        {v:'Anzahl Mängel\nRisiko mittel', s: { fill:this.fillMedium } } ,     // Q
        {v:'Schätzkosten\nRisiko mittel', s: { fill:this.fillMedium } } ,      // R
        {v:'Anzahl Mängel\nRisiko gering', s: { fill:this.fillLow } } ,        // S
        {v:'Schätzkosten\nRisiko gering', s: { fill:this.fillLow } }  ]        // T
      ];
      this.colsFacility = [];
      for (let header of this.dataFacility[0]) {
        let len= header.v.toString().length;
        this.colsFacility.push( {wch:len+ bufferChars});
      }
      this.colsFacility[0] = {wch:this.colCharsWidth+bufferChars}; // anlage
      this.colsFacility[1] = {wch:this.colCharsWidth+bufferChars}; // strasse
      this.colsFacility[3] = {wch:this.colCharsWidth+bufferChars}; // Ort
      this.colsFacility[4] = {wch:this.colCharsWidth+bufferChars}; // transportiert
      let lenRisks = 'Anzahl Mängel Risiko mittel'.length/2 + bufferChars; // 2 lines
      this.colsFacility[11] = {wch:'Bericht'.length + bufferChars};
      this.colsFacility[13] = {wch:lenRisks};
      this.colsFacility[14] = {wch:lenRisks};
      this.colsFacility[15] = {wch:lenRisks};
      this.colsFacility[16] = {wch:lenRisks};
      this.colsFacility[17] = {wch:lenRisks};
      this.colsFacility[18] = {wch:lenRisks};
      this.rowsFacility = [{hpt:2*15}]; // 2 rows a 15 points for header-row

      this.dataRisks = [[]];
      this.colsRisks = [];
      this.rowsRisk = [{hpt:3*15}]; // 3 rows a 15 points for header-row


      for (let i=0; i<13; i++) {
        this.dataRisks[0].push(this.dataFacility[0][i]);
        this.colsRisks.push(this.colsFacility[i])
      }
      this.dataRisks[0].push(
          {v:'Mangel'},                                   // N
          {v:'Risiko'},                                   // O
          {v:'Schätzkosten'},                             // P
          {v:'Schätzkosten\noptionale\nSchutzmaßnahmen'}  // Q
      );
      this.colsRisks[13] = {wch:this.colCharsWidth + bufferChars + 10};   // N Mangel
      this.colsRisks[14] = {wch:'Risiko'.length + bufferChars};           // O Risiko
      this.colsRisks[15] = {wch:'Schätzkosten'.length + bufferChars};     // P Schätzkosten
      this.colsRisks[16] = {wch:'Schutzmaßnahmen'.length + bufferChars};  // Q Schätzkosten optionale Schutzmaßnahmen

    },

    addFacilityToData(facility) {
      let ti = facility.technicalInfo;
      let separator = '';
      let transporting = '';
      if (ti === null) {
        ti = {};
      }
      if (ti.transportPerson) {
        transporting = 'Personenaufzug';
        separator = '/';
      }
      if (ti.transportFreight) {
        transporting += separator + 'Lastenaufzug';
        separator = '/';
      }
      if (ti.transportGoods) {
        transporting += separator + 'Güteraufzug'
        separator = '/';
      }


      let inspectionDate = DateUtils.parseDateForVuetify(facility.inspectionDate);
      let driveType = ti.drive ?  this.$t('enums:technical.drive.'+ti.drive) : '';
      let hasReport = facility.gbu.jsonSelectedProtections !== null;
      let hasCostEstimate = facility.gbu.hasCostEstimate && hasReport;

      let cellsAM = [
        {v:facility.name}, {v:facility.buildingStreet}, {v:facility.buildingZip}, {v:facility.buildingCity},
        {v:transporting},
        {v:ti.maxLoad ? ti.maxLoad : '', t:'n'},
        {v:ti.stations ? ti.stations: '', t:'n'},
        {v:ti.operatingSpeed ? ti.operatingSpeed : '', t:'n'},
        {v:driveType}, {v:ti.engineRoomExists ? 'ja' :'nein'},
        {v:inspectionDate, t:'d', z:'dd.mmm.yyyy'},
        {v: hasReport ? 'ja': 'nein'},
        {v: hasReport && hasCostEstimate ? 'ja': 'nein'},
      ];

      // calculate number of lines
      let maxLen = 0;
      for (let cell of cellsAM) {
        maxLen = Math.max (cell.v.toString().length , maxLen);
      }
      let maxLines = Math.ceil(maxLen/this.colCharsWidth);
      this.rowsFacility.push({hpt:maxLines*15});

      let gbuChecks = JSON.parse(facility.gbu.jsonContent);


      let selProtections = hasReport ? JSON.parse(facility.gbu.jsonSelectedProtections) : null;
      let failedChecks = [];
      let changedRisks = selProtections && selProtections.risk ? selProtections.risk : [];
      let riskIndex = 0;
      for (let chapter of gbuChecks.chapters) {
        for (let check of chapter.checks) {
          if (check.risk !== 'info' && check.isRisk && check.isRisk.toString().toLowerCase() === 'ja') {
            failedChecks.push(check);
            if (riskIndex >= changedRisks.length ) {
              continue;
            }
            while(changedRisks[riskIndex].nr < check.nr) {
              riskIndex++;
            }
            if (changedRisks[riskIndex].nr === check.nr) {
              //console.log(check.nr, check.risk, "->",changedRisks[riskIndex].risk); //debug
              check.risk = changedRisks[riskIndex].risk;
              riskIndex++;
            }
          }
        }
      }
      if (gbuChecks.useSurroundingsConsideration) {
        for (let chapter of gbuChecks.surroundingsChapters) {
          for (let check of chapter.checks) {
            if (check.isRisk.toString().toLowerCase() === 'ja' && check.risk !== 'info') {
              failedChecks.push(check);
              if (riskIndex >= changedRisks.length ) {
                continue;
              }
              while(changedRisks[riskIndex].nr < check.nr) {
                riskIndex++;
              }
              if (changedRisks[riskIndex].nr === check.nr) {
                //console.log(check.nr, check.risk, "->",changedRisks[riskIndex].risk); //debug
                check.risk = changedRisks[riskIndex].risk;
                riskIndex++;
              }
            }
          }
        }
      }
      let nrHigh = 0;
      let nrMedium = 0;
      let nrLow = 0;
      for (let check of failedChecks) {
        let risk =check.risk.toString().toLowerCase();
        if ( this.isRiskHigh(check)) {
          nrHigh++;
        }
        else if (this.isRiskMedium(check)) {
          nrMedium++;
        }
        else if ( this.isRiskLow(check)) {
          nrLow++;
        }
        else if (risk === 'info') {
          continue;
        }
        else {
          console.error('error - gbu-data corrupt - invalid risk '+risk);
          console.error(JSON.stringify(check,null,2)) ;
          return;
        }
      }

      let costFacility = {hoch:0, mittel:0, niedrig:0 };
      if (hasReport) {
        let indexCheck = 0;
        for (let prot of selProtections.protections) {
          let nrProt = prot.nr;
          // format of checks: Umfeldbetrachtung: B1.a  GBU: 1.2.b
          let [p1, p2, p3] = nrProt.split('.',3);
          let nrCheckFromProtection = p3 === undefined ? p1 : p1 + '.' + p2;
          let nrCheck = failedChecks[indexCheck].nr;
          if (nrCheckFromProtection !== nrCheck) {
            indexCheck++;
            nrCheck = failedChecks[indexCheck].nr;
          }
          if (nrCheckFromProtection !== nrCheck) {
            console.error('error - corrupt GBU for facility:'+facility.name);
            return;
          }
          let currentCheck = failedChecks[indexCheck];
          if (currentCheck.selectedProtections === undefined) {  // Lift-657 remark: currentcheck.protections already contains all_protections in gbu version 3+
            currentCheck.selectedProtections = [prot];
            currentCheck.sumCost = 0;
            currentCheck.sumAlternativeCost = 0;
            currentCheck.nrAlternativeProtections = 0; // # of protections not included in regular cost sum
          }
          else {
            currentCheck.selectedProtections.push(prot);
          }
          if (hasCostEstimate) {
            if (prot.incSum) {
              currentCheck.sumCost += prot.cost;
              if (this.isRiskHigh(currentCheck)) {
                costFacility['hoch'] += prot.cost;
              }
              else if (this.isRiskMedium(currentCheck)) {
                costFacility['mittel'] += prot.cost;
              }
              else if (this.isRiskLow(currentCheck)) {
                costFacility['niedrig'] += prot.cost;
              }
            }
            else {
              currentCheck.sumAlternativeCost += prot.cost;
              currentCheck.nrAlternativeProtections++;
            }
          }
        }
      }

      for (let check of failedChecks) {
        let failedCheck = check.nr + ' ' + check.check;
        let risk = check.risk.toString();
        let fillRisk =
            this.isRiskHigh(check) ? this.fillHigh :
                this.isRiskMedium(check) ? this.fillMedium :
                    this.isRiskLow(check) ? this.fillLow : this.fillWhite;
        let nrLines = Math.ceil( failedCheck.length / this.colCharsWidth);
        if (nrLines < maxLines) {
          nrLines = maxLines;
        }
        this.rowsRisk.push({hpt:nrLines*15});
        this.dataRisks.push([...cellsAM,
          {v:failedCheck, s:{fill:fillRisk}},
          {v:risk, s:{fill:fillRisk} },
          {v:hasCostEstimate ? check.sumCost :'', t:'n', z: this.cellFormatEuro,
            s:{ fill: hasCostEstimate ? fillRisk : this.fillGray} },
          {v:hasCostEstimate ? check.sumAlternativeCost :'', t:'n', z: this.cellFormatEuro,
            s:{ fill: hasCostEstimate ? check.sumAlternativeCost > 0 ? fillRisk : this.fillWhite : this.fillGray} }
        ]);
      }


      if (hasReport && hasCostEstimate) {
        this.dataFacility.push([...cellsAM,
          {v: nrHigh, t: 'n', s:{fill: nrHigh > 0 ? this.fillHigh : this.fillWhite}},
          {v: costFacility['hoch'], t: 'n', z: this.cellFormatEuro,
            s:{fill: costFacility['hoch'] > 0 ? this.fillHigh : this.fillWhite }},
          {v: nrMedium, t: 'n', s:{fill: nrMedium > 0 ? this.fillMedium : this.fillWhite}},
          {v: costFacility['mittel'], t: 'n', z: this.cellFormatEuro,
            s:{fill: costFacility['mittel'] > 0 ? this.fillMedium : this.fillWhite }},
          {v: nrLow, t: 'n', s:{fill: nrLow > 0 ? this.fillLow : this.fillWhite}},
          {v: costFacility['niedrig'], t: 'n', z: this.cellFormatEuro,
            s:{fill: costFacility['niedrig'] > 0 ? this.fillLow : this.fillWhite }},
        ]);
      } else {
        this.dataFacility.push([...cellsAM,
          {v: nrHigh, t: 'n', s:{fill: nrHigh > 0 ? this.fillHigh : this.fillWhite}},
          {v: '', t:'n', s:{fill: nrHigh > 0 ? this.fillGray : this.fillWhite}},
          {v: nrMedium, t: 'n', s:{fill: nrMedium > 0 ? this.fillMedium : this.fillWhite}},
          {v: '', t:'n', s:{fill: nrMedium > 0 ? this.fillGray : this.fillWhite}},
          {v: nrLow, t: 'n', s:{fill: nrLow > 0 ? this.fillLow : this.fillWhite}},
          {v: '', t:'n', s:{fill: nrLow > 0 ? this.fillGray : this.fillWhite}},
        ]);
      }
    },

    isRiskHigh(check) {
      return check.risk.toString().toLowerCase().startsWith('hoch');
    },
    isRiskMedium(check) {
      return check.risk.toString().toLowerCase().startsWith('mittel');
    },
    isRiskLow(check) {
      return check.risk === null || check.risk.toString().toLowerCase().startsWith('niedrig');
    },
    saveDataToExcel() {
      let thinBorderStyle = {style:'thin', color: {rgb:'000000'}};
      let thinBorder = {  bottom: thinBorderStyle, right:thinBorderStyle }
      let alignment = { wrapText: true, vertical:'center' };
      for (let row of [...this.dataFacility, ...this.dataRisks] ) {
        for (let cell of row) {
          if (!cell.s) {
            cell.s = {border: thinBorder, alignment: alignment};
          }
          else {
            cell.s.border = thinBorder;
            cell.s.alignment = alignment;
          }
        }
        row[0].s.border.left = thinBorderStyle;
      }
      for (let row of [this.dataFacility[0], this.dataRisks[0]] ) {
        for (let cell of row) {
          cell.s.border.top = thinBorderStyle;
        }
      }

      let sumBorder = {
        top: {style: 'thin', color:{rgb: '000000'}},
        right: {style: 'thin', color:{rgb: '000000'}},
        bottom: {style: 'thin', color:{rgb: '000000'}},
      };
      let sumBorderFirst = {
        top: {style: 'thin', color:{rgb: '000000'}},
        bottom: {style: 'thin', color:{rgb: '000000'}},
        right: {style: 'thin', color:{rgb: '000000'}},
        left: {style: 'thin', color:{rgb: '000000'}}
      }
      let sumRowFacility = [null, null, null, null, null,    null, null, null, null, null,
        null, null, null,
        {v:undefined, s: {
          font: { bold: true } ,
          border: sumBorderFirst,
          fill: this.fillHigh
        }},
        {v:undefined, z:this.cellFormatEuro, s: {
            font: {bold: true },
            border: sumBorder,
            fill: this.fillHigh
        }},
        {v:undefined, s: {
            font: { bold: true },
            border:sumBorder,
            fill: this.fillMedium
        } },
        {v:undefined, z:this.cellFormatEuro, s: {font: { bold: true },
            border: sumBorder,
            fill: this.fillMedium
        } },
        {v:undefined, s: {font: { bold: true},
            border: sumBorder,
            fill: this.fillLow
        } },
        {v:undefined, z:this.cellFormatEuro, s: {font: { bold: true },
            border: sumBorder,
            fill: this.fillLow
        } },
      ];
      this.dataFacility.push(sumRowFacility);
      this.rowsFacility.push({hpt:1*15});

      let sumRowRisk = [null, null, null, null, null,    null, null, null, null, null,
        null, null, null, null, null,
        {v:undefined, z:this.cellFormatEuro,
            s: {font: { bold: true },
            border: sumBorderFirst
          }},
        {v:undefined, z:this.cellFormatEuro,
          s: {font: { bold: true },
            border: sumBorder
          }},
      ];
      this.dataRisks.push(sumRowRisk);
      this.rowsRisk.push({hpt:1*15});

      let workSheetFacility = XLSX.utils.aoa_to_sheet(this.dataFacility);
      workSheetFacility['!cols'] = this.colsFacility;
      workSheetFacility['!rows'] = this.rowsFacility;

      let nrRows = this.dataFacility.length;
      if (nrRows > 2) {
        workSheetFacility['!autofilter'] = {ref: "A1:S" + (nrRows-1)};
        let ranges = [ 'N'+nrRows, 'O'+nrRows, 'P'+nrRows, 'Q'+nrRows, 'R'+nrRows, 'S'+nrRows, ];
        let formulas= [
          'SUBTOTAL(9,N2:N'+(nrRows-1)+')', 'SUBTOTAL(9,O2:O'+(nrRows-1)+')',
          'SUBTOTAL(9,P2:P'+(nrRows-1)+')', 'SUBTOTAL(9,Q2:Q'+(nrRows-1)+')',
          'SUBTOTAL(9,R2:R'+(nrRows-1)+')', 'SUBTOTAL(9,S2:S'+(nrRows-1)+')' ];
        for (let i = 0; i< ranges.length; i++ ) {
          XLSX.utils.sheet_set_array_formula(workSheetFacility, ranges[i], formulas[i] );
        }
      }

      let workSheetRisks = XLSX.utils.aoa_to_sheet(this.dataRisks);
      workSheetRisks['!cols'] = this.colsRisks;
      workSheetRisks['!rows'] = this.rowsRisk;
      nrRows = this.dataRisks.length;
      if (nrRows > 2) {
        workSheetRisks['!autofilter'] = {ref: "A1:Q" + (nrRows - 1)};
        XLSX.utils.sheet_set_array_formula(workSheetRisks, 'P'+nrRows,
            'SUBTOTAL(9,P2:P'+(nrRows-1)+')' );
        XLSX.utils.sheet_set_array_formula(workSheetRisks, 'Q'+nrRows,
            'SUBTOTAL(9,Q2:Q'+(nrRows-1)+')' );

      }

      let  workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheetFacility, "Anlagen");
      XLSX.utils.book_append_sheet(workBook, workSheetRisks, "Mängel");


      // Exporting the file with the desired name and extension.
      const excelBuffer = XLSX.write(workBook, { bookType: "xlsx", type: "array", cellStyles:true  });

      DocumentationService.download('GBU-Export.xlsx', excelBuffer);
    },
    onCustomerSelectChange(changedCustomerId) {
      if (!changedCustomerId) {
        return;
      }
      this.isDataLoaded = false;
      this.selectedItems = [];
      this.nrSelectedItems = 0;
      FacilityService.readForGbuExportByCustomer( changedCustomerId,
          this.readForGbuExportSucessHandler,
          () => {
            this.isDataLoaded = true;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:facility_plural')}));
          }
      )
    }
  }

}
</script>

<style scoped>

</style>